import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=6b4cb4ed&scoped=true"
import script from "./ImageZoom.vue?vue&type=script&lang=js"
export * from "./ImageZoom.vue?vue&type=script&lang=js"
import style0 from "./ImageZoom.vue?vue&type=style&index=0&id=6b4cb4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cb4ed",
  null
  
)

export default component.exports